<template lang="pug">
.applicant-waiters-list-tab(v-cloak)
  .mb-3
  RoomNameExample
  .mb-2
  WaiterTable(
    v-model="_items"
    :fields="fields"
    :totalRows.sync="_rows"
    :currentPage.sync="currentPage"
    :perPage="perPage"
    :isLoading="isLoading"
    :filter="filter"
    @onStatusEdit="onStatusEdit"
    @onLabelEdit="onLabelEdit"
    @onOtherFacilitiesApplication="onOtherFacilitiesApplication"
    @onServiceRegisterGuide="onServiceRegisterGuide"
    @onConfirm="onConfirm"
    @onApplyingForCancel="onApplyingForCancel"
    @onDetails="onDetails"
    @onDelete="onDelete"
  )
  .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
    // 詳細検索
    .flex-fill.mr-2
      button.btn.advanced-filters-btn(@click="showAdvancesFilesr =! showAdvancesFilesr") 
        span(v-show="!showAdvancesFilesr") 詳細検索を表示
        span(v-show="showAdvancesFilesr") 詳細検索を非表示
    // 検索
    .search-filter.d-flex.mr-1.align-items-center.mr-2
      b-input-group.search-filter-input-group.mr-1(size="md")
        b-input-group-prepend
          b-input-group-text.search-filter-icon
            .search-icon
        b-form-input.search-filter-input(v-model="filter.searchWord" type="search" placeholder="検索ワードを入力してください")
      HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="applicant-waiter-search-filter-help" title="検索項目について")
        template(v-slot:text)
          div 検索項目は以下になります。
          div ・入所申込者名
          div ・入所申込者名（ふりがな）
    // ページあたりの行数
    span.table-option-text 1ページの行数:
    .per-page
      b-form-select(
        id="applicant-waiters-list-tab-per-page-select"
        v-model="perPage"
        :options="pageOptions"
        size="md"
        @change="selectPerPage"
      )
    // ページネーション
    b-pagination.m-0(
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      :disabled="isLoading"
      @change="selectPage"
      hide-goto-end-buttons
    )
  .advanced-filters.mt-2.p-2(v-if="showAdvancesFilesr")
    .d-flex.flex-row.flex-wrap
      // フィルタリング(ステップ)
      .advanced-filter.mr-2.align-self-start
        span.table-option-text.font-weight-bold ステップ:
        b-form-checkbox(v-model="filter.status.application") 入所申込み
        b-form-checkbox(v-model="filter.status.receivedApplication") 申込み受理
        b-form-checkbox(v-model="filter.status.completeApplication") 判定済
        b-form-checkbox(v-model="filter.status.confirmAdmission") 入所意向確認
        b-form-checkbox(v-model="filter.status.finalJudge") 最終判定中
        b-form-checkbox(v-model="filter.status.completeFinalJudge") 最終判定済
        b-form-checkbox(v-model="filter.status.admissionProcedure") 入所手続き
      // 性別
      .advanced-filter.mr-2.align-self-start
        span.table-option-text.font-weight-bold 性別:
        b-form-checkbox(v-model="filter.gender.men") 男性
        b-form-checkbox(v-model="filter.gender.women") 女性
      // 部屋種別
      .advanced-filter.mr-2.align-self-start
        span.table-option-text.font-weight-bold 部屋種別:
        b-form-checkbox(v-if="_facility.recruitmentRoom.multiBed" v-model="filter.roomType.multiBed") 従来型多床室
        b-form-checkbox(v-if="_facility.recruitmentRoom.conventinalSingle" v-model="filter.roomType.conventinalSingle") 従来型個室
        b-form-checkbox(v-if="_facility.recruitmentRoom.unitTypeSingle" v-model="filter.roomType.unitTypeSingle") ユニット型個室
        b-form-checkbox(v-if="_facility.recruitmentRoom.single" v-model="filter.roomType.single") 個室
        b-form-checkbox(v-if="_facility.recruitmentRoom.double" v-model="filter.roomType.double") ２人部屋（夫婦部屋）
        b-form-checkbox(v-for="roomType in filter.customRoomType" v-model="roomType.value" :key="roomType.id") {{ roomType.name }}
      // 要介護度
      .advanced-filter.mr-2.align-self-start
        span.table-option-text.font-weight-bold 要介護度:
        b-form-checkbox(v-model="filter.careLevel.careLevel1000") 自立
        b-form-checkbox(v-model="filter.careLevel.careLevel1010") 申請中
        b-form-checkbox(v-model="filter.careLevel.careLevel2010") 要支援１
        b-form-checkbox(v-model="filter.careLevel.careLevel2020") 要支援２
        b-form-checkbox(v-model="filter.careLevel.careLevel3010") 要介護１
        b-form-checkbox(v-model="filter.careLevel.careLevel3020") 要介護２
        b-form-checkbox(v-model="filter.careLevel.careLevel3030") 要介護３
        b-form-checkbox(v-model="filter.careLevel.careLevel3040") 要介護４
        b-form-checkbox(v-model="filter.careLevel.careLevel3050") 要介護５
      // ラベル
      .advanced-filter.mr-2.align-self-start
        span.table-option-text.font-weight-bold ラベル:
        .d-flex.flex-row
          .d-flex.flex-column
            .label(v-for="(label, index) in filter.labels.slice(0, 5)")
              b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
          .d-flex.flex-column.ml-2(v-if="0 < filter.labels.slice(5, 10).length")
            .label(v-for="(label, index) in filter.labels.slice(5, 10)")
              b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
          .d-flex.flex-column.ml-2(v-if="0 < filter.labels.slice(10, 15).length")
            .label(v-for="(label, index) in filter.labels.slice(10, 15)")
              b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
          .d-flex.flex-column.ml-2(v-if="0 < filter.labels.slice(15, 20).length")
            .label(v-for="(label, index) in filter.labels.slice(15, 20)")
              b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
      // リセットボタン
      button.btn.advanced-setting-reset-btn(@click="resetAdvacedSetting") リセット
</template>

<script lang="ts">
import { Component, Watch, Prop, Inject, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";
import Setting from "../../../../public/setting.json";

import WaiterLabelsService, { WaiterLabelsGetModel } from "@/commons/services/WaiterLabels";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";
import { FacilityGetModel } from "@/commons/services/Facilities";

import HelpIcon from "@/pc/basics/HelpIcon.vue";
import RoomNameExample from "@/pc/containers/waiters/RoomNameExample.vue";
import WaiterTable, { WaiterTableField, WaiterTableItem, FilterSetting, FilterLabel, FilterCustomRoomType } from "@/pc/containers/waiters/WaiterTable.vue";

/**
 * ### 変更申請中待機者一覧画面コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    RoomNameExample,
    WaiterTable
  }
})
export default class ApplicantWaiterListTab extends Vue {
  /** 待機者ラベルサービス */
  @Inject("WaiterLabelsService") waiterLabelsService!: WaiterLabelsService;

  /** 読込み中か否か */
  @Prop()
  isLoading!: boolean;
  /** 行情報 */
  @Prop()
  items!: Array<WaiterTableItem>;
  /** ページングの全体行数 */
  @Prop()
  rows!: number;

  /** 列名 */
  fields: Array<WaiterTableField> = [];
  /** フィルタリング条件 */
  filter: FilterSetting = {
    searchWord: "",
    status: {
      application: false,
      receivedApplication: false,
      completeApplication: false,
      confirmAdmission: false,
      finalJudge: false,
      completeFinalJudge: false,
      admissionProcedure: false
    },
    gender: { men: false, women: false },
    roomType: {
      multiBed: false,
      conventinalSingle: false,
      unitTypeSingle: false,
      single: false,
      double: false
    },
    customRoomType: [],
    careLevel: {
      careLevel1000: false,
      careLevel1010: false,
      careLevel2010: false,
      careLevel2020: false,
      careLevel3010: false,
      careLevel3020: false,
      careLevel3030: false,
      careLevel3040: false,
      careLevel3050: false
    },
    labels: []
  };
  /** 詳細検索条件 */
  showAdvancesFilesr: boolean = false;
  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.waiter.applicantWaiterListTable.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.waiter.applicantWaiterListTable.pageOptions;

  get _items(): Array<WaiterTableItem> {
    return this.items;
  }

  get _rows(): number {
    return this.rows;
  }

  set _rows(newValue: number) {
    this.$emit("update:rows", newValue);
    return;
  }

  get _facility(): FacilityGetModel {
    return userStore.getFacility;
  }

  /**
   * ### 1ページあたりの表示行数の変更イベント
   *
   * - 変更をクッキーに持たせる
   */
  @Watch("perPage")
  public changePerPage(perPage: number): void {
    this.setCookie(perPage);

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `applicant-waiter-list-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  /**
   * vue lifecycle mounted
   *
   * 画面表示情報の作成を行う
   */
  public async mounted(): Promise<void> {
    // 画面初期表示時に作成して変更しないものを初期化する
    const fields: Array<WaiterTableField> = this.createFields();
    this.fields = fields;
    // 1ページあたりの表示行数はCookieから取得する。取得できない場合はデフォルト値を使用する
    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.waiter.applicantWaiterListTable.perPage);

    const labels: Array<WaiterLabelsGetModel> = await this.getWaiterLabels();
    const filterLabels: Array<FilterLabel> = this.createFilterLabels(labels);
    this.filter.labels = filterLabels;

    const customRoomType: Array<FilterCustomRoomType> = this.createFilterCustomRoomType();
    this.filter.customRoomType = customRoomType;

    return;
  }

  /**
   * ### 列名を作成する
   */
  public createFields(): Array<WaiterTableField> {
    let fields: Array<WaiterTableField> = [];

    fields.push({ key: "type", label: "申請内容", sortable: false, sortDirection: "desc", class: "type" });
    fields.push({ key: "cancelReason", label: "届け出理由", sortable: false, sortDirection: "desc", class: "cancel-reason" });
    fields.push({ key: "applyingOperation", label: "対応", sortable: false, sortDirection: "desc", class: "applying-operation text-center" });
    fields.push({ key: "step", label: "ステップ", sortable: false, sortDirection: "desc", class: "step" });
    fields.push({ key: "name", label: "入所申込者名", sortable: false, sortDirection: "desc", class: "name" });
    fields.push({ key: "rooms", label: "申込み部屋", sortable: false, sortDirection: "desc", class: "rooms" });
    fields.push({ key: "applicationDate", label: "申込日・最終更新日", sortable: false, sortDirection: "desc", class: "application-date" });
    if (WaiterServicePlanType.ENTERPRISE <= userStore.facility.waiterServicePlanType) {
      fields.push({ key: "otherFacility", label: "他施設の申込", sortable: false, sortDirection: "desc", class: "other-facility" });
    }
    fields.push({ key: "operation", label: "登録情報", sortable: false, sortDirection: "desc", class: "operation" });

    return fields;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["applicant-waiter-list-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  /**
   * ### 待機者ラベルを取得する
   */
  public async getWaiterLabels(): Promise<Array<WaiterLabelsGetModel>> {
    const response: Array<WaiterLabelsGetModel> = await this.waiterLabelsService.gets(userStore);
    return response;
  }

  /**
   * ### 待機者ラベルフィルタリング選択肢を作成する
   */
  public createFilterLabels(labels: Array<WaiterLabelsGetModel>): Array<FilterLabel> {
    let filterLabels: Array<FilterLabel> = [];
    for (const label of labels) {
      filterLabels.push({
        ...label,
        checked: false
      });
    }
    return filterLabels;
  }

  /**
   * ### 部屋種類フィルタリング選択肢を作成する
   */
  public createFilterCustomRoomType(): Array<FilterCustomRoomType> {
    let filterCustomRoomType: Array<FilterCustomRoomType> = [];
    if (userStore.facility.customRecruitmentRoom) {
      for (const room of userStore.facility.customRecruitmentRoom) {
        if (room.use == true) {
          filterCustomRoomType.push({
            id: room.id,
            name: room.name,
            value: false
          });
        }
      }
    }
    return filterCustomRoomType;
  }

  /**
   * ### 1ページあたりの表示行数変更イベント
   *
   * - 1ページあたりの表示行数を更新
   * - ページあたりの表示行数が変わるので表の情報を作り直す
   */
  public async selectPerPage(perPage: number): Promise<void> {
    this.perPage = perPage;
    this.currentPage = 1;
    this.$emit("changeDisplayTarget");
    return;
  }

  /**
   * ### ページネーションのページ番号押下
   */
  public async selectPage(page: number): Promise<void> {
    this.currentPage = page;
    this.$emit("changeDisplayTarget");
    return;
  }

  public onStatusEdit(item: WaiterTableItem): void {
    this.$emit("onStatusEdit", item);
    return;
  }

  /**
   * ### ラベルの編集ボタン押下イベント
   */
  public onLabelEdit(item: WaiterTableItem): void {
    this.$emit("onLabelEdit", item);
    return;
  }

  public onOtherFacilitiesApplication(item: WaiterTableItem): void {
    this.$emit("onOtherFacilitiesApplication", item);
    return;
  }

  public onServiceRegisterGuide(item: WaiterTableItem): void {
    this.$emit("onServiceRegisterGuide", item);
    return;
  }

  public onConfirm(item: WaiterTableItem): void {
    this.$emit("onConfirm", item);
    return;
  }

  public onApplyingForCancel(item: WaiterTableItem, answer: boolean): void {
    this.$emit("onApplyingForCancel", item, answer);
    return;
  }

  public onDetails(item: WaiterTableItem): void {
    this.$emit("onDetails", item);
    return;
  }

  public onDelete(item: WaiterTableItem): void {
    this.$emit("onDelete", item);
    return;
  }

  public resetAdvacedSetting(): void {
    this.filter.status.application = false;
    this.filter.status.receivedApplication = false;
    this.filter.status.completeApplication = false;
    this.filter.status.confirmAdmission = false;
    this.filter.status.finalJudge = false;
    this.filter.status.completeFinalJudge = false;
    this.filter.status.admissionProcedure = false;

    this.filter.gender.men = false;
    this.filter.gender.women = false;

    this.filter.roomType.multiBed = false;
    this.filter.roomType.conventinalSingle = false;
    this.filter.roomType.unitTypeSingle = false;
    this.filter.roomType.single = false;
    this.filter.roomType.double = false;

    for (const roomType of this.filter.customRoomType) {
      roomType.value = false;
    }

    this.filter.careLevel.careLevel1000 = false;
    this.filter.careLevel.careLevel1010 = false;
    this.filter.careLevel.careLevel2010 = false;
    this.filter.careLevel.careLevel2020 = false;
    this.filter.careLevel.careLevel3010 = false;
    this.filter.careLevel.careLevel3020 = false;
    this.filter.careLevel.careLevel3030 = false;
    this.filter.careLevel.careLevel3040 = false;
    this.filter.careLevel.careLevel3050 = false;

    for (const label of this.filter.labels) {
      label.checked = false;
    }

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.applicant-waiters-list-tab {
  width: 100%;

  .waiter-label {
    margin: 2px 0;
    font-size: 12px;
    padding: 4px;
    border-radius: 0.25rem;
  }

  .advanced-setting-reset-btn {
    height: 32px !important;
    font-size: 16px !important;
  }
}
</style>
